import React, { useEffect, useState } from 'react';
import ComanServices from '../../../services/ComanServices';
import useAsync from '../../../hooks/useAsync';
import { POLICY_DEFAULTS, readPolicy, buildPolicyUpdate } from '../../front/policyDefaults';
import ReactQuill from 'react-quill';  // Import react-quill
import 'react-quill/dist/quill.snow.css';  // Import react-quill styles

function PrivacyPolicy() {
  const { data, error, isLoading, run } = useAsync(ComanServices.getPolicy);
  const [formData, setFormData] = useState({
    title: '',
    description: ''  // Will store HTML content
  });

  useEffect(() => {
    if (data) {
      console.log(data);
      setFormData({
        title: readPolicy(data?.data, 'privacyPolicy')?.title || '',
        description: readPolicy(data?.data, 'privacyPolicy')?.description || ''
      });
    }
  }, [data]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  // Handle rich text editor changes for description
  const handleDescriptionChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      description: value  // The value will be the HTML content from the editor
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Call update API
      const response = await ComanServices.updatePolicy(buildPolicyUpdate(data?.data, 'privacyPolicy', formData));
      console.log(response);
      alert('Privacy policy updated successfully!');
    } catch (error) {
      alert('Error updating privacy policy.');
    }
  };

  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Error loading privacy policy.</p>;

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>Privacy Policy</h2>
      </div>
      <div className="container-box px-5">
        <div className="page-details">
          <form onSubmit={handleSubmit}>
            <div className="input-field">
              <label>Title</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div className="input-field">
              <label>Description</label>
              <ReactQuill
                theme="snow"
                value={formData.description}  // The HTML content
                onChange={handleDescriptionChange}  // Handle editor changes
                className="form-control"
              />
            </div>
            <button
              type="button"
              className="btn btn-outline-secondary me-3"
              onClick={() => {
                if (!formData.description || window.confirm('Replace the current text with the recommended privacyPolicy text? Click SUBMIT afterwards to save it.')) {
                  setFormData({ ...POLICY_DEFAULTS.privacyPolicy });
                }
              }}
            >
              Use recommended text
            </button>
            <button className="submit-green-btn" type="submit">
              SUBMIT
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
